import { useTranslation } from 'react-i18next'

/** Locale-matched public destinations shared by the landing and legal header and footer. */
export function usePublicHrefs() {
  const { i18n } = useTranslation()
  const prefix = i18n.resolvedLanguage === 'zh-TW' ? '/blog/zh-tw/' : '/blog/'
  return {
    guide: prefix,
    updates: `${prefix}changes/`,
    sources: `${prefix}how-we-check/`,
    rss: `${prefix}rss.xml`,
  }
}
